<script lang="ts">
	import * as Sidebar from '#lib/components/ui/sidebar/index.js'
	import * as Tooltip from '#lib/components/ui/tooltip/index.js'
	import AppHeader from '#lib/layouts/app-header.svelte'
	import AppSidebar from '#lib/layouts/app-sidebar.svelte'
	import { metricDialog } from '#lib/utils/dialogs.svelte.js'

	let { children } = $props()
</script>

<AppHeader class="md:hidden" />

<!-- Below md the header above takes `--app-header-height`, so the rest fills one screen -->
<Sidebar.Provider class="min-h-[calc(100svh-var(--app-header-height))] md:min-h-svh">
	<AppSidebar />

	<Sidebar.Inset class="w-[calc(100%-var(--sidebar-width))]">
		<Tooltip.Provider>
			{@render children?.()}
		</Tooltip.Provider>
	</Sidebar.Inset>
</Sidebar.Provider>

{#if metricDialog.open}
	{#await import('#lib/components/dialogs/metric-dialog.svelte') then MetricDialog}
		<MetricDialog.default />
	{/await}
{/if}
